import type { Chat } from "~models"
import { ChatTypes } from "~proto"

type ChatRoomPayload = {
  id: number
  chat_id: string
  title?: string
  image?: string
  is_mute?: boolean
  creator_id?: number
}

type ResolveDeps = {
  apiStore: {
    getChatRoomId: (params: { username: string }) => Promise<{ data?: ChatRoomPayload }>
  }
  chatStore: {
    getChat: (id: string) => Chat | undefined
    _putChat: (data: Record<string, unknown>) => Chat
  }
  userStore: {
    currentUser: { id: number }
  }
}

/** 私聊发红包/转账前补全服务端 chat_id（数字 id + cid），无需先发消息 */
export async function resolvePrivateChatServerIds(
  chat: Chat | null | undefined,
  deps: ResolveDeps,
): Promise<{ serverChatId: number; chatCid: string } | null> {
  if (!chat || chat.chatTypeEnum !== "PRIVATE") return null

  if (chat.id != null && chat.id > 0) {
    return { serverChatId: chat.id, chatCid: String(chat.chat_id) }
  }

  const receiver = chat.receiver
  const username = receiver?.username
  if (!receiver?.id || !username) return null

  const res = await deps.apiStore.getChatRoomId({ username })
  const room = res?.data
  if (!room?.id || !room?.chat_id) return null

  let target = deps.chatStore.getChat(room.chat_id)
  if (!target) {
    target = deps.chatStore._putChat({
      id: room.id,
      chat_id: room.chat_id,
      title: room.title || receiver.name || chat.title || "",
      type: ChatTypes.PRIVATE,
      creator_id: room.creator_id ?? deps.userStore.currentUser.id,
      receiver_id: receiver.id,
      image: room.image,
      is_mute: room.is_mute,
    })
  } else if (!target.id || target.id <= 0) {
    target.setID(room.id)
  }

  if (chat !== target && (!chat.id || chat.id <= 0)) {
    chat.setID(room.id)
  }

  return { serverChatId: room.id, chatCid: String(room.chat_id) }
}
